import React from "react";
import MarkdownMathText from "./MarkdownMathText";
import { handoutChoiceColumns, splitHandoutChoices } from "../../features/handoutQuestionTypography";

const atomicBlanks = (text) => String(text).split(/([＿_]{3,})/g).map((part, index) =>
  /^[＿_]{3,}$/.test(part) ? <span key={index} data-word-answer-blank style={{ display: "inline-block", whiteSpace: "nowrap" }}>{part}</span> : part);

export function HandoutWordQuestionText({ source, settings, widthCm }) {
  const { stem, options } = splitHandoutChoices(source);
  const columns = handoutChoiceColumns(options, settings.optionsLayout, widthCm, Number(settings.bodyFontSize) || 14);
  return <><MarkdownMathText source={stem} formatText={atomicBlanks} />{options.length > 0 && <div data-handout-options-columns={columns}
    style={{ display: "grid", gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`, gap: "2pt 12pt", marginTop: "2pt", whiteSpace: "normal" }}>
    {options.map((option) => <div key={option.label} style={{ display: "grid", gridTemplateColumns: "1.8em minmax(0, 1fr)", breakInside: "avoid" }}>
      <span>({option.label})</span><MarkdownMathText source={option.text} formatText={atomicBlanks} />
    </div>)}
  </div>}</>;
}

export function HandoutWordAnswer({ source, settings }) {
  return <div data-word-answer style={{ color: "#f00", fontSize: `${settings.answerFontSize ?? 12}pt`,
    fontWeight: settings.answerBold ? 700 : 400, marginLeft: "0.25in", display: "flex", gap: "3pt", alignItems: "baseline" }}>
    <span>【答案】</span><MarkdownMathText source={source} />
  </div>;
}
